import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
export var getAwsChunkedEncodingStream = function getAwsChunkedEncodingStream(readableStream, options) {
  var base64Encoder = options.base64Encoder,
    bodyLengthChecker = options.bodyLengthChecker,
    checksumAlgorithmFn = options.checksumAlgorithmFn,
    checksumLocationName = options.checksumLocationName,
    streamHasher = options.streamHasher;
  var checksumRequired = base64Encoder !== undefined && bodyLengthChecker !== undefined && checksumAlgorithmFn !== undefined && checksumLocationName !== undefined && streamHasher !== undefined;
  var digest = checksumRequired ? streamHasher(checksumAlgorithmFn, readableStream) : undefined;
  var reader = readableStream.getReader();
  return new ReadableStream({
    pull: function pull(controller) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$reader$read, value, done, checksum;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return reader.read();
              case 2:
                _yield$reader$read = _context.sent;
                value = _yield$reader$read.value;
                done = _yield$reader$read.done;
                if (!done) {
                  _context.next = 18;
                  break;
                }
                controller.enqueue("0\r\n");
                if (!checksumRequired) {
                  _context.next = 15;
                  break;
                }
                _context.t0 = base64Encoder;
                _context.next = 11;
                return digest;
              case 11:
                _context.t1 = _context.sent;
                checksum = (0, _context.t0)(_context.t1);
                controller.enqueue("".concat(checksumLocationName, ":").concat(checksum, "\r\n"));
                controller.enqueue("\r\n");
              case 15:
                controller.close();
                _context.next = 19;
                break;
              case 18:
                controller.enqueue("".concat((bodyLengthChecker(value) || 0).toString(16), "\r\n").concat(value, "\r\n"));
              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  });
};